import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  FormControl,
  FormLabel,
  FormControlLabel,
  Switch,
  Divider,
  Chip,
} from '@mui/material';
import { useTimeLynxxTheme } from '../contexts/ThemeContext';

export const Settings: React.FC = () => {
  const { mode, toggleMode } = useTimeLynxxTheme();

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Settings
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Configure your TimeLynxx admin portal preferences
      </Typography>

      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Appearance
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Customize how TimeLynxx looks and feels
          </Typography>

          <FormControl component="fieldset">
            <FormLabel component="legend">Theme Mode</FormLabel>
            <Box sx={{ mt: 2 }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={mode === 'dark'}
                    onChange={toggleMode}
                    color="primary"
                  />
                }
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    Dark Mode
                    <Chip 
                      label={mode === 'dark' ? 'On' : 'Off'} 
                      size="small" 
                      variant="outlined"
                      color={mode === 'dark' ? 'primary' : 'default'}
                    />
                  </Box>
                }
              />
            </Box>
          </FormControl>

          <Divider sx={{ my: 3 }} />

          <Box>
            <Typography variant="subtitle2" gutterBottom>
              Brand Colors
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Box
                  sx={{
                    width: 20,
                    height: 20,
                    borderRadius: 1,
                    backgroundColor: 'primary.main',
                  }}
                />
                <Typography variant="body2">Primary (#2C97A3)</Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Box
                  sx={{
                    width: 20,
                    height: 20,
                    borderRadius: 1,
                    backgroundColor: 'secondary.main',
                  }}
                />
                <Typography variant="body2">Secondary (#FF6B35)</Typography>
              </Box>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};